"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The SurvivorUpdateRequest model module.
 * @module model/SurvivorUpdateRequest
 * @version 1.0.0
 */
var SurvivorUpdateRequest = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>SurvivorUpdateRequest</code>.
   * @alias module:model/SurvivorUpdateRequest
   * @param firstName {String} 
   * @param lastName {String} 
   * @param phone {String} 
   * @param email {String} 
   * @param alertStatus {String} 
   * @param address1 {String} 
   * @param address2 {String} 
   * @param city {String} 
   * @param state {String} 
   * @param country {String} 
   * @param county {String} 
   */
  function SurvivorUpdateRequest(firstName, lastName, phone, email, alertStatus, address1, address2, city, state, country, county) {
    _classCallCheck(this, SurvivorUpdateRequest);

    SurvivorUpdateRequest.initialize(this, firstName, lastName, phone, email, alertStatus, address1, address2, city, state, country, county);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(SurvivorUpdateRequest, null, [{
    key: "initialize",
    value: function initialize(obj, firstName, lastName, phone, email, alertStatus, address1, address2, city, state, country, county) {
      obj['first_name'] = firstName;
      obj['last_name'] = lastName;
      obj['phone'] = phone;
      obj['email'] = email;
      obj['alert_status'] = alertStatus;
      obj['address1'] = address1;
      obj['address2'] = address2;
      obj['city'] = city;
      obj['state'] = state;
      obj['country'] = country;
      obj['county'] = county;
    }
    /**
     * Constructs a <code>SurvivorUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SurvivorUpdateRequest} obj Optional instance to populate.
     * @return {module:model/SurvivorUpdateRequest} The populated <code>SurvivorUpdateRequest</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new SurvivorUpdateRequest();

        if (data.hasOwnProperty('first_name')) {
          obj['first_name'] = _ApiClient.default.convertToType(data['first_name'], 'String');
        }

        if (data.hasOwnProperty('last_name')) {
          obj['last_name'] = _ApiClient.default.convertToType(data['last_name'], 'String');
        }

        if (data.hasOwnProperty('phone')) {
          obj['phone'] = _ApiClient.default.convertToType(data['phone'], 'String');
        }

        if (data.hasOwnProperty('email')) {
          obj['email'] = _ApiClient.default.convertToType(data['email'], 'String');
        }

        if (data.hasOwnProperty('alert_status')) {
          obj['alert_status'] = _ApiClient.default.convertToType(data['alert_status'], 'String');
        }

        if (data.hasOwnProperty('address1')) {
          obj['address1'] = _ApiClient.default.convertToType(data['address1'], 'String');
        }

        if (data.hasOwnProperty('address2')) {
          obj['address2'] = _ApiClient.default.convertToType(data['address2'], 'String');
        }

        if (data.hasOwnProperty('city')) {
          obj['city'] = _ApiClient.default.convertToType(data['city'], 'String');
        }

        if (data.hasOwnProperty('state')) {
          obj['state'] = _ApiClient.default.convertToType(data['state'], 'String');
        }

        if (data.hasOwnProperty('postal_code')) {
          obj['postal_code'] = _ApiClient.default.convertToType(data['postal_code'], 'String');
        }

        if (data.hasOwnProperty('country')) {
          obj['country'] = _ApiClient.default.convertToType(data['country'], 'String');
        }

        if (data.hasOwnProperty('county')) {
          obj['county'] = _ApiClient.default.convertToType(data['county'], 'String');
        }

        if (data.hasOwnProperty('opt_in_news')) {
          obj['opt_in_news'] = _ApiClient.default.convertToType(data['opt_in_news'], 'Boolean');
        }

        if (data.hasOwnProperty('events_interest')) {
          obj['events_interest'] = _ApiClient.default.convertToType(data['events_interest'], 'Boolean');
        }

        if (data.hasOwnProperty('le_connection')) {
          obj['le_connection'] = _ApiClient.default.convertToType(data['le_connection'], 'Boolean');
        }

        if (data.hasOwnProperty('how_learned_pcc')) {
          obj['how_learned_pcc'] = _ApiClient.default.convertToType(data['how_learned_pcc'], 'String');
        }

        if (data.hasOwnProperty('other_non_profit')) {
          obj['other_non_profit'] = _ApiClient.default.convertToType(data['other_non_profit'], 'Boolean');
        }

        if (data.hasOwnProperty('other_victim_services')) {
          obj['other_victim_services'] = _ApiClient.default.convertToType(data['other_victim_services'], 'Boolean');
        }

        if (data.hasOwnProperty('case_id')) {
          obj['case_id'] = _ApiClient.default.convertToType(data['case_id'], 'Number');
        }
      }

      return obj;
    }
  }]);

  return SurvivorUpdateRequest;
}();
/**
 * @member {String} first_name
 */


SurvivorUpdateRequest.prototype['first_name'] = undefined;
/**
 * @member {String} last_name
 */

SurvivorUpdateRequest.prototype['last_name'] = undefined;
/**
 * @member {String} phone
 */

SurvivorUpdateRequest.prototype['phone'] = undefined;
/**
 * @member {String} email
 */

SurvivorUpdateRequest.prototype['email'] = undefined;
/**
 * @member {String} alert_status
 */

SurvivorUpdateRequest.prototype['alert_status'] = undefined;
/**
 * @member {String} address1
 */

SurvivorUpdateRequest.prototype['address1'] = undefined;
/**
 * @member {String} address2
 */

SurvivorUpdateRequest.prototype['address2'] = undefined;
/**
 * @member {String} city
 */

SurvivorUpdateRequest.prototype['city'] = undefined;
/**
 * @member {String} state
 */

SurvivorUpdateRequest.prototype['state'] = undefined;
/**
 * @member {String} postal_code
 */

SurvivorUpdateRequest.prototype['postal_code'] = undefined;
/**
 * @member {String} country
 */

SurvivorUpdateRequest.prototype['country'] = undefined;
/**
 * @member {String} county
 */

SurvivorUpdateRequest.prototype['county'] = undefined;
/**
 * @member {Boolean} opt_in_news
 */

SurvivorUpdateRequest.prototype['opt_in_news'] = undefined;
/**
 * @member {Boolean} events_interest
 */

SurvivorUpdateRequest.prototype['events_interest'] = undefined;
/**
 * @member {Boolean} le_connection
 */

SurvivorUpdateRequest.prototype['le_connection'] = undefined;
/**
 * @member {String} how_learned_pcc
 */

SurvivorUpdateRequest.prototype['how_learned_pcc'] = undefined;
/**
 * @member {Boolean} other_non_profit
 */

SurvivorUpdateRequest.prototype['other_non_profit'] = undefined;
/**
 * @member {Boolean} other_victim_services
 */

SurvivorUpdateRequest.prototype['other_victim_services'] = undefined;
/**
 * @member {Number} case_id
 */

SurvivorUpdateRequest.prototype['case_id'] = undefined;
var _default = SurvivorUpdateRequest;
exports.default = _default;